import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=7af77698&"
import script from "./sidebar.vue?vue&type=script&lang=ts&"
export * from "./sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports